export default "__VITE_ASSET__8ad8fde9__"